// extracted by mini-css-extract-plugin
export default {"organizationsContainer":"OrganizationSelect_organizationsContainer__eaG1r"};